<template>
    <div 
        class="table-base"
        :class="{'preloader-content': isPreloader}"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <table>
            <thead>
                <tr>
                    <th
                        v-for="(columnKey, indexColumnKey) of columns.keys()"
                        :key="indexColumnKey"
                        :style="getStyleCell(columnKey)"
                        class="table-base__td-name"
                    >
                        <table-header
                            :isSort="isSort && isColumnSort(columnKey)"
                            :sortState="getColumnSortState(columnKey)"
                            :title="columns.get(columnKey)"
                            @onToggleSort="onToggleSort($event, columnKey)"
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(row, indexRow) of rowsBuffer"
                    :key="indexRow"
                >
                    <td
                        v-for="(columnKey, indexColumnKey) of columns.keys()"
                        :key="indexColumnKey"
                        :style="getStyleCell(columnKey)"
                    >
                        {{getCell(row[columnKey])}}
                        <table-chart-bar
                            v-if="false && isColumnChartBar(columnKey)"
                            :totalValue="getChartBarTotalValue(columnKey, row)"
                            :fillValues="getChartBarFillValues(columnKey, row)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import TableHeader from './TableHeader';
import TableChartBar from './TableChartBar';
import mixinTable from '../../mixins/mixinTable';
export default {
    name: 'TableBaseV2',
    components: {
        TableHeader,
        TableChartBar
    },
    mixins: [
        mixinTable
    ],
    /**
     * Входные данные компонента
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {Map} columns - колонки
     * @property {Array} rows - строки
     * @property {Object} columnsStyles - стили колонок
     * @property {boolean} isSort - вкл/откл сортировку
     * @property {Object} columnsSort - колонки которые можно сортировать
     * @property {Object} columnsChartBar - колонки с гистограммой
     */
    props: {
        isPreloader: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Map,
            default: () => (new Map())
        },
        rows: {
            type: Array,
            default: () => ([])
        },
        columnsStyles: {
            type: Object,
            default: () => ({})
        },
        isSort: {
            type: Boolean,
            default: false
        },
        columnsSort: {
            type: Object,
            default: () => ({})
        },
        columnsChartBar: {
            type: Object,
            default: () => ({})
        }
    },
    /**
     * данные компонента
     * @property {Array} rowsBuffer - буферный массив строк
     * @property {number} sortState - состояние сортировки
     * @property {string} sortColumn - ключ колонки по которой сортируем
     */
    data: () => ({
        rowsBuffer: [],
        sortState: 0,
        sortColumn: ''
    }),
    mounted() {
        // перезаписываем буферный массив строк
        this.rowsBuffer = this.rows.slice();
    },
    watch: {
        /**
         * следим за обновлением строк из пропса 
         * и обновляем буферный массив, состояние сортровки и ключа колонки по которой сортируем
         */
        rows: function() {
            this.rowsBuffer = this.rows.slice();
            this.sortState = 0;
            this.sortColumn = '';
        }
    },
    methods: {
        /**
         * получить стиль ячейки
         * @param {string} columnKey - ключь колонки
         * @returns {Object}
         */
        getStyleCell(columnKey = '') {
            let styleCell = this.columnsStyles.hasOwnProperty(columnKey) ? this.columnsStyles[columnKey] : {};
            return styleCell;
        },
        /**
         * получить значение ячейки
         * @param {(string|number)} cell - ячейка
         * @returns {string}
         */
        getCell(cell = '') {
            let formattedCell = typeof cell === 'number' ? cell.toLocaleString('ru-RU') : cell;
            return formattedCell;
        },
        /**
         * проверить можно ли сортировать по данной колонке
         * @param {string} columnKey - ключ колонки
         * @returns {boolean}
         */
        isColumnSort(columnKey = '') {
            let isColumnSort = Object.keys(this.columnsSort).includes(columnKey);
            return isColumnSort;
        },
        /**
         * проверить имеет ли колонка гистограмму
         * @param {string} columnKey - ключ колонки
         * @returns {boolean}
         */
        isColumnChartBar(columnKey = '') {
            let isColumnChartBar = Object.keys(this.columnsChartBar).includes(columnKey);
            return isColumnChartBar;
        },
        /**
         * получить состояние сортировки колонки
         * @param {string} columnKey - ключ колонки
         * @returns {number}
         */
        getColumnSortState(columnKey = '') {
            let columnSortState = this.sortColumn === columnKey ? this.sortState : 0;
            return columnSortState;
        },
        /**
         * получить значение 100% ширины для гистограммы
         * @param {string} columnKey - ключ колонки
         * @param {Object} row - строка
         * @returns {number}
         */
        getChartBarTotalValue(columnKey = '', row = {}) {
            let {totalValue = null, totalValueCallback = null} = this.columnsChartBar[columnKey];
            let chartBarTotalValue = null;
            if (totalValue !== null)
                chartBarTotalValue = totalValue;
            else
                if (totalValueCallback !== null)
                    chartBarTotalValue = totalValueCallback(row);
            return chartBarTotalValue;
        },
        /**
         * получить значения для закрашивания гистограммы
         * @param {string} columnKey - ключ колонки
         * @param {Object} row - строка
         * @returns {Array}
         */
        getChartBarFillValues(columnKey = '', row = {}) {
            let {fillKeys = []} = this.columnsChartBar[columnKey];
            let chartBarFillValues = fillKeys.map(fillKey => row[fillKey]);
            return chartBarFillValues;
        },
        /**
         * переключение режима сортировки
         * @param {string} currentSortState - текущее состояние режима сортировки
         * @param {string} column - колонка по которой сортируем
         */
        onToggleSort(currentSortState = 0, columnKey = '') {
            if(currentSortState === Object.keys(this.sortStates).length - 1)
                this.sortState = 0;
            else
                this.sortState = currentSortState + 1;
            this.sortColumn = columnKey;
            let typeSort = this.sortStates[this.sortState].type;
            if (typeSort === 'none')
                this.rowsBuffer = this.rows;
            else {
                if (this.columnsSort[columnKey].typeColumn === 'Number')
                    this.rowsBuffer = this.sortNumberArray(typeSort, this.rowsBuffer.slice(), columnKey, false);
                if (this.columnsSort[columnKey].typeColumn === 'String')
                    this.rowsBuffer = this.sortStringArray(typeSort, this.rowsBuffer.slice(), columnKey);
                if (this.columnsSort[columnKey].typeColumn === 'Percent')
                    this.rowsBuffer = this.sortPercentArray(typeSort, this.rowsBuffer.slice(), columnKey);
                if (this.columnsSort[columnKey].typeColumn === 'Month')
                    this.rowsBuffer = this.sortMonthArray(typeSort, this.rowsBuffer.slice(), columnKey);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .table-base {
        position: relative;
        width: 100%;
        border-radius: 10px;
        overflow-x: auto;
        border: 3px solid #f5f7f9;
    }
    table {
        width: 100%;
        color: #818284;
        border-collapse: collapse;
        border-spacing: 0;
    }
    thead {
        border-bottom: 3px solid #f5f7f9;
    }
    thead th {
        text-align: left;
        font-weight: bold;
        text-transform: uppercase;
        color: #000;
        letter-spacing: 0.07em;
        word-break: break-all;
        font-size: 0.65em;
    }
    thead th, tbody td {
        padding: 16px 14px;
    }
    thead th, tbody td {
        border-bottom: 1px solid #f5f7f9;
    }
    .table-base__td-name {
        color: #000;
    }
    .table-base__th-name {
        cursor: pointer;
    }
</style>